import { Link } from "react-router-dom";
import { ArrowRight, Ticket, Store, Map, Users, HelpCircle, Mail } from "lucide-react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Seo } from "@/components/site/Seo";
import { TicketAvailabilityBanner } from "@/components/site/TicketAvailabilityBanner";
import { useT } from "@/i18n/LanguageContext";

const TEASERS = [
  {
    to: "/tickets",
    icon: Ticket,
    titleKey: "nav.tickets",
    desc: "Tagestickets für Erwachsene, Kinder & Familien — direkt online buchbar.",
  },
  {
    to: "/booths",
    icon: Store,
    titleKey: "nav.booths",
    desc: "Standgrößen von 1 Tisch bis zur Premium-Insel inkl. Aussteller-Tickets.",
  },
  {
    to: "/hallenplan",
    icon: Map,
    titleKey: "nav.hallenplan",
    desc: "Interaktiver Hallenplan — wähle deinen Stand direkt auf der Karte.",
  },
  {
    to: "/aussteller",
    icon: Users,
    titleKey: "nav.exhibitors",
    desc: "Wer ist dieses Jahr dabei? Stöbere durch die offizielle Aussteller-Liste.",
  },
  {
    to: "/faq",
    icon: HelpCircle,
    titleKey: "nav.faq",
    desc: "Antworten zu Anreise, Einlass, Bezahlung und Standflächen.",
  },
  {
    to: "/kontakt",
    icon: Mail,
    titleKey: "nav.contact",
    desc: "Frag uns alles — wir antworten meist innerhalb von 24 h.",
  },
];

export default function HomePage() {
  const { t } = useT();
  return (
    <div data-testid="home-page" className="bg-[#0a0a0a] text-white min-h-screen">
      <Seo
        title="Cologne Card Con 2026 · Sammelkarten- & Sportkarten-Messe Köln"
        description="Cologne Card Con – die Messe für Sammelkarten & Sportkarten in Köln am 06.09.2026, Halle Tor 2. Pokémon, Magic, One Piece, Yu-Gi-Oh, NBA & NFL. Tickets & Stände jetzt online sichern."
        path=""
      />
      <Header />
      <main>
        <Hero />
        <TicketAvailabilityBanner />
        <About />
        {/* Navigation teasers replacing the long-scroll homepage sections */}
        <section className="section" data-testid="home-teasers">
          <div className="max-w-6xl mx-auto">
            <div className="eyebrow gold-text mb-3">Schnellzugriff</div>
            <h2 className="font-display font-black text-3xl md:text-4xl mb-10 tracking-tighter">
              Wohin möchtest du?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {TEASERS.map(({ to, icon: Icon, titleKey, desc }) => (
                <Link
                  key={to}
                  to={to}
                  data-testid={`home-teaser-${to.slice(1)}`}
                  className="group relative bg-[#141414] border border-white/10 hover:border-[#FFCC51]/40 rounded-2xl p-6 transition-all hover:bg-[#181818] hover:shadow-[0_0_30px_rgba(255,215,0,0.07)]"
                >
                  <div className="flex items-start justify-between gap-3 mb-3">
                    <div className="w-11 h-11 rounded-xl bg-[#FFCC51]/10 border border-[#FFCC51]/30 flex items-center justify-center group-hover:bg-[#FFCC51]/15 transition-colors">
                      <Icon size={20} className="text-[#FFCC51]" />
                    </div>
                    <ArrowRight
                      size={18}
                      className="text-zinc-500 group-hover:text-[#FFCC51] group-hover:translate-x-1 transition-all"
                    />
                  </div>
                  <div className="font-display font-bold text-white text-xl mb-1.5">
                    {t(titleKey)}
                  </div>
                  <p className="text-zinc-400 text-sm leading-relaxed">{desc}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
